export default () => {
  // 配食サービスパン
  const pamphletDl = () => {
    const target = document.querySelector("#pamphletdl");
    if (!target) return;
    target.addEventListener("click", (event) => {
      window.dataLayer.push({
        file: "pamphlet",
        event: "file-dl",
      });
    });

    // 介護事業パン
    const target2 = document.querySelector("#pamphletdl2");
    if (!target2) return;
    target2.addEventListener("click", (event) => {
      window.dataLayer.push({
        file: "pamphlet-kaigo",
        event: "file-dl",
      });
    });
  };
  pamphletDl();
};
